// Generated by CoffeeScript 2.7.0
var Admin__YetAnotherWorkflow__GraphsController;

import Flow from 'trunks/vue/admin/compositions/yet_another_workflow/flow.js';

import FlowMoreOperations from './concerns/flow_more_operations.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

export default Admin__YetAnotherWorkflow__GraphsController = (function() {
  class Admin__YetAnotherWorkflow__GraphsController extends Skylark.App.BaseController {
    index() {
      this.__toggleNavMenu();
      this.flow = new Skylark.App.Model.YetAnotherWorkflow.Flow(this.getVars('flow'));
      return new Flow({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('yet-another-workflow_graph_container'),
        propsData: {
          graph: this.flow.graph
        }
      });
    }

    _doRepairFlow() {}

  };

  Admin__YetAnotherWorkflow__GraphsController.include(FlowMoreOperations, ToggleNavMenuAction);

  return Admin__YetAnotherWorkflow__GraphsController;

}).call(this);
